import { ReactElement } from 'react';
import { Prompt } from 'react-router-dom';
import { Props } from './NavigationPrompt.types';
import { NavigationPromptModal } from './NavigationPromptModal';

export const NavigationPrompt = ({
  isModalOpened,
  onNavigationBlock,
  onNavigationCancel,
  onNavigationConfirm,
  shouldConfirmNavigation,
}: Props): ReactElement => (
  <>
    <Prompt
      message={onNavigationBlock}
      when={shouldConfirmNavigation}
    />
    <NavigationPromptModal
      isOpen={isModalOpened}
      onNavigationCancel={onNavigationCancel}
      onNavigationConfirm={onNavigationConfirm}
    />
  </>
);
